import React from 'react';
import Logo from '../Logo';

/**
 * Shown briefly between tapping "Start Recording" and the onsite agent
 * confirming it has connected to the camera and FFmpeg is running. On a
 * healthy LAN this is usually a couple of seconds — long enough to need
 * its own screen, short enough that it shouldn't look like a stall.
 */
export default function StartingScreen({ courtName, playerEmail }) {
  return (
    <div style={s.page}>
      <div style={s.topBar}>
        <span style={s.logo}><Logo size={22} style={{ marginRight: 8, verticalAlign: -6 }} />Picklers Lounge</span>
        <span style={s.courtChip}>{courtName}</span>
      </div>

      <div style={s.center}>
        <div style={s.card} className="fade-in">
          <span style={s.spinner} />
          <p style={s.title}>Connecting to camera…</p>
          {playerEmail && (
            <p style={s.subtitle}>
              Starting recording for <strong style={s.playerName}>{playerEmail}</strong>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh', background: 'var(--gray-900)',
    display: 'flex', flexDirection: 'column',
    fontFamily: 'var(--font)',
  },
  topBar: {
    height: 60, padding: '0 28px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    background: 'rgba(255,255,255,0.05)',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
  },
  logo: { fontSize: 17, fontWeight: 700, color: 'white' },
  courtChip: {
    background: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.8)',
    fontSize: 13, fontWeight: 600,
    padding: '5px 14px', borderRadius: 50,
  },
  center: {
    flex: 1, display: 'flex',
    alignItems: 'center', justifyContent: 'center', padding: 24,
  },
  card: {
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 'var(--radius-lg)',
    padding: '56px 40px',
    width: '100%', maxWidth: 460,
    textAlign: 'center',
    backdropFilter: 'blur(20px)',
  },
  spinner: {
    width: 40, height: 40, borderRadius: '50%',
    border: '3px solid rgba(255,255,255,0.15)',
    borderTopColor: 'white',
    animation: 'spin 0.8s linear infinite',
    display: 'inline-block',
    marginBottom: 28,
  },
  title: {
    fontSize: 22, fontWeight: 600, color: 'white',
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 15, color: 'rgba(255,255,255,0.55)',
  },
  playerName: { color: 'rgba(255,255,255,0.85)', fontWeight: 600 },
};
